import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import { removeSnackbar } from '../../store/actions/alert'

import { List, ListItem, ListItemText, Typography, IconButton } from '@material-ui/core'
import Alerts from '@material-ui/lab/Alert'
import { AlertTitle } from '@material-ui/lab'
import CloseIcon from '@material-ui/icons/Close'
import Aux from '../../hoc/Auxiliary/Auxiliary'
import { withTranslate } from 'react-redux-multilingual'
import classes from './Alert.scss'
let displayed = []
const Alert = ({ translate }) => {
  const dispatch = useDispatch()
  const notifications = useSelector(store => store.alert.notifications || [])
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const storeDisplayed = id => {
    displayed = [...displayed, id]
  }

  const removeDisplayed = id => {
    displayed = [...displayed.filter(key => id !== key)]
  }

  React.useEffect(() => {
    notifications.forEach(({ key, message, options = {}, dismissed = false }) => {
      message = `${message}`.replace('.', '')
      if (dismissed) {
        // dismiss snackbar using notistack
        closeSnackbar(key)
        return
      }
      let content = (alertKey, alertMessage, data) => {
        let col = null
        alertMessage = `${alertMessage || ''}`.replace('.', '')
        if (data) {
          const list = Object.entries(data).map(res => {
            let [key, arrayMsg] = res

            return (
              <Aux key={key}>
                <ListItem alignItems='flex-start' dense={true} divider={true}>
                  <ListItemText
                    primary={
                      <React.Fragment>
                        {key}
                        {arrayMsg.map(msg => {
                          msg = `${msg}`.replace('.', '')
                          return (
                            <div>
                              <Typography
                                component='span'
                                className={classes.Text}
                                key={msg}
                                variant='body2'>
                                {translate(msg || '') || msg}
                              </Typography>
                            </div>
                          )
                        })}
                      </React.Fragment>
                    }
                  />
                </ListItem>
              </Aux>
            )
          })
          col = <List>{list}</List>
        }
        return (
          <Alerts
            variant='filled'
            severity={options.variant}
            className={classes.Alert}
            action={
              <IconButton className={classes.Alert} onClick={() => closeSnackbar(alertKey)}>
                <CloseIcon />
              </IconButton>
            }>
            <AlertTitle>{translate(alertMessage || '') || alertMessage}</AlertTitle>

            {col}
          </Alerts>
        )
      }
      // do nothing if snackbar is already displayed
      if (displayed.includes(key)) return
      if (options.withOption) {
      }
      // display snackbar using notistack
      enqueueSnackbar(message, {
        key,
        ...options,

        persist: options.variant !== 'success',
        content: content(key, message, options.data),

        onClose: (event, reason, myKey) => {
          if (options.onClose) {
            options.onClose(event, reason, myKey)
          }
        },
        onExited: (event, myKey) => {
          // removen this snackbar from redux store
          dispatch(removeSnackbar(myKey))
          removeDisplayed(myKey)
        }
      })

      // keep track of snackbars that we've displayed
      storeDisplayed(key)
    })
  }, [notifications, closeSnackbar, enqueueSnackbar, dispatch, translate])

  return null
}
export default withTranslate(Alert)
